@if (teamGroupedObjectives) {
    <ul class="mb-0">
        @for (group of teamGroupedObjectives; track group; let first = $first) {
            <li>
                <ul class="mb-0"
                    [ngClass]="{ 'mt-2': !first }">
                    @if (currentPageTeamId !== group.team?.teamId) {
                        <adapt-link-objectives-page [team]="group.team"
                                                    [addObjectiveTextSuffix]="showGroupObjectiveTextSuffix"></adapt-link-objectives-page>
                    }
                    <ul class="related-objectives">
                        @for (childObjective of group.objectives; track childObjective) {
                            <li class="d-flex align-items-baseline gap-1">
                                <adapt-link-objective [objective]="childObjective"
                                                      [showAssigneeImage]="true"
                                                      [ngClass]="{
                                        'flex-grow-1 blurred-summary': blurTitle && !childObjective.isOrganisationObjective && !childObjective.team?.allowObjectivesTeamRead,
                                    }">
                                </adapt-link-objective>
                                @if (!objective?.isClosed && hasEditPermissions) {
                                    <button adaptButtonIcon="deleteBorderless"
                                            class="btn btn-link"
                                            (click)="removeObjectiveLink(childObjective)"
                                            adaptTooltip="Delete objective link"></button>
                                }
                            </li>
                        }
                    </ul>
                </ul>
            </li>
        }
    </ul>
}
